<script>
import {HorizontalBar} from 'vue-chartjs';

export default {
    extends: HorizontalBar,

    props: {
        rawData: {default: false},
        media: {default: 'media-canvas'},
        type: {default: 'male'},
        chartId: {default: false}
    },

    data() {
        return {
            data: null,
            settings: {
                male: {
                    counter: 'views',
                    color: '#2958ff',
                    textColor: '#000',
                    hovergradient: '#a6a9ba',
                },
                female: {
                    counter: 'plays',
                    color: '#a5a9b9',
                    textColor: '#FFF',
                    hovergradient: '#a6a9ba',
                }                  
            }            
        }
    },

    mounted () {
        // this.storeData();
    },

    methods: {
        storeData() {
            var ctx = document.getElementById(`${this.chartId}`).getContext('2d');

            var labels = this.rawData[this.type].labels.slice(0,500);
            var datasets = this.rawData[this.type].datasets.slice(0,500);

            this.data = {
                labels: labels,
                datasets: [{
                    label: 'Plays',
                    backgroundColor: this.settings[this.type].color, 
                    borderWidth: 0,
                    borderColor: this.settings[this.type].hovergradient,
                    data: datasets,
                }],
            }

            if ( this.rawData[this.type].datasets.length ){
                $("#"+ this.chartId).parent().css("display", "block");
                $("#"+ this.chartId).parent().css("height", this.rawData[this.type].datasets.length * 42 + 40);
            }else{
                $("#"+ this.chartId).parent().css("display", "none");
            }

            this.renderChart(this.data, this.options);
        }
    },

    computed: {
        getMin(){
            var m = this.rawData.male.datasets.concat(this.rawData.female.datasets).sort(function(a, b) { return Math.abs(b) - Math.abs(a) });
            return (this.type == 'female' ? 0 : -Math.abs(m[0]));
        },

        getMax(){
            var m = this.rawData.male.datasets.concat(this.rawData.female.datasets).sort(function(a, b) { return Math.abs(b) - Math.abs(a) });
            return (this.type == 'male' ? 0 : Math.abs(m[0]));
        },

        options() {
            return {
                type: this.type,
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                },
                layout: {
                    padding:{
                        left: 25,
                    }
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            callback: function(label, index, labels) {
                                return this.chart.options.type == 'male' ? -label : label;
                            },
                            suggestedMax: this.getMx,
                            suggestedMin: this.getMin,
                            beginAtZero: true,
                            padding: 10,
                        },

                        gridLines: {
                            drawTicks: false,
                            drawBorder: true,
                        }
                    }],
                    yAxes: [{
                        display: false,
                        ticks: {
                            mirror: true,
                            fontColor: "rgba(255,255,255, 1)",
                            fontSize: 12,
                        },

                        gridLines: {
                            drawBorder: false,
                            display: false, // hides the grid lines from this axis
                            offsetGridLines: false,
                        }
                    }],
                },

                tooltips: {
                    enabled: false,
                },

                animation: {
                    onProgress () {
                        if (this.chart.options.type == 'male') return;

                        const chartInstance = this.chart;
                        const ctx = chartInstance.ctx;
                        const meta = chartInstance.controller.getDatasetMeta(0);

                        Chart.helpers.each(meta.data.forEach((bar, index) => {
                            var dataset = this.data.datasets[0].data;
                            var value = parseInt(dataset[index]);
                            var formatted = value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
                            var txt = this.data.labels[index];

                            ctx.font = "11px Source Sans Pro";
                            ctx.textBaseline = 'middle';
                            
                            ctx.fillStyle = '#1f2136';
                            ctx.fillRect(0, bar._model.y - 11, 50, 22);

                            ctx.textAlign = 'center';
                            ctx.fillStyle = '#fff';
                            ctx.fillText(txt, 25, bar._model.y);
                        }));
                    },
                }
            };
        },
    },

    watch: {
        rawData(){
            this.storeData();
        }
    }    
}
</script>